import { createApp } from 'vue'
import store from 'store'

import PromotionCollections from './PromotionCollections.vue'

const el = '.nti-component--promotion'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(PromotionCollections)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}